import { Box, Typography } from '@mui/material';
import { HotelRatingDisplay } from './HotelRatingDisplay';

interface HotelBasicInfoProps {
  name: string;
  rating: number;
  impressions: number;
}

export const HotelBasicInfo = ({ name, rating, impressions }: HotelBasicInfoProps) => {
  return (
    <Box>
      <Typography variant="h6">{name}</Typography>
      <HotelRatingDisplay rating={rating} impressions={impressions} />
    </Box>
  );
};
